(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1880],{

/***/ 88284:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legalCenter",
      function () {
        return __webpack_require__(75303);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _layout_MainLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81842);
/* harmony import */ var _layout_centerLayout_CenterLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33134);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);





function LegalCenter() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        setTimeout(function() {
            router.replace("/legalCenter/termsOfService");
        }, 100);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_MainLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_centerLayout_CenterLayout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            children: function() {}
        })
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (LegalCenter);


/***/ }),

/***/ 33134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ centerLayout_CenterLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js + 17 modules
var mobxreact_esm = __webpack_require__(50828);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__(28677);
// EXTERNAL MODULE: ./src/layout/centerLayout/CenterLayout.module.scss
var CenterLayout_module = __webpack_require__(47472);
var CenterLayout_module_default = /*#__PURE__*/__webpack_require__.n(CenterLayout_module);
// EXTERNAL MODULE: ./src/components/common/ServicePlatformChoice/ServicePlatformChoice.js
var ServicePlatformChoice = __webpack_require__(43051);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/store/index.js + 10 modules
var store = __webpack_require__(26721);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./styles/pages/center/breadCrumbs.module.scss
var breadCrumbs_module = __webpack_require__(37125);
var breadCrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadCrumbs_module);
;// CONCATENATED MODULE: ./src/components/pages/center/breadCrumbs.js







function BreadCrumbs(param) {
    var _detail = param.detail, detail = _detail === void 0 ? {} : _detail;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)("pages").t;
    var breadCrumbsArr = router.pathname.split("/").filter(function(breadCrumbs) {
        return breadCrumbs !== "";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (breadCrumbs_module_default()).breadCrumbs,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (breadCrumbs_module_default()).crumb,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: t("home.header")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (breadCrumbs_module_default()).arrow,
                children: ">"
            }),
            breadCrumbsArr.map(function(breadCrumbs, index) {
                var linkBuilder = "";
                var textBuilder = "";
                var match = breadCrumbs.match(/\[(.*?)\]/);
                if (match) {
                    var newArray = breadCrumbsArr.map(function(item) {
                        return item.replace(match[0], router.query[match[1]]);
                    });
                    linkBuilder = newArray.slice(0, index + 1).join("/");
                    textBuilder = detail.title ? detail.title : router.query[match[1]];
                } else {
                    linkBuilder = breadCrumbsArr.slice(0, index + 1).join("/");
                    textBuilder = t("".concat(breadCrumbsArr.slice(0, index + 1).join("."), ".header"));
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (breadCrumbs_module_default()).crumb,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/".concat(linkBuilder),
                                children: t("".concat(textBuilder))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (breadCrumbs_module_default()).arrow,
                            children: ">"
                        })
                    ]
                }, breadCrumbs);
            })
        ]
    });
}
BreadCrumbs.propTypes = {
    detail: prop_types_default().instanceOf(Object)
};
BreadCrumbs.defaultProps = {
    detail: {}
};
/* harmony default export */ var breadCrumbs = (BreadCrumbs);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/pages/center/imgs/SideBarIcon.js
var SideBarIcon = __webpack_require__(89290);
// EXTERNAL MODULE: ./styles/pages/center/sideBar.module.scss
var sideBar_module = __webpack_require__(91179);
var sideBar_module_default = /*#__PURE__*/__webpack_require__.n(sideBar_module);
;// CONCATENATED MODULE: ./src/components/pages/center/sideBar.js








function SideBar() {
    var ref;
    var router = (0,next_router.useRouter)();
    var pathNameArr = router.pathname.split("/").filter(function(x) {
        return x !== "";
    });
    var t = (0,esm/* useTranslation */.$G)("pages").t;
    var keyPrefix = ((ref = pathNameArr[0]) === null || ref === void 0 ? void 0 : ref.replace("App", "")) || "";
    var textObj = t(keyPrefix, {
        returnObjects: true
    });
    var combineNav = typeof textObj === "object" ? Object.keys(textObj).filter(function(x) {
        return x !== "header";
    }) : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (sideBar_module_default()).tabs,
        children: combineNav.map(function(section) {
            var linkBuilder = [
                "",
                pathNameArr[0]
            ].concat(section).join("/");
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: linkBuilder,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((sideBar_module_default()).tabBlock, (0,_define_property/* default */.Z)({}, (sideBar_module_default()).active, pathNameArr.includes(section))),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (sideBar_module_default()).tabRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBarIcon/* default */.Z, {
                                icon: section
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("".concat(keyPrefix, ".").concat(section, ".header"))
                            })
                        ]
                    })
                })
            }, section);
        })
    });
}
/* harmony default export */ var sideBar = (SideBar);

;// CONCATENATED MODULE: ./src/layout/centerLayout/CenterLayout.js













function CenterLayout(param) {
    var children = param.children, _detail = param.detail, detail = _detail === void 0 ? "" : _detail, _showBreadcrumbs = param.showBreadcrumbs, showBreadcrumbs = _showBreadcrumbs === void 0 ? true : _showBreadcrumbs, _nativeApp = param.nativeApp, nativeApp = _nativeApp === void 0 ? false : _nativeApp;
    var ref;
    var router = (0,next_router.useRouter)();
    var user = (0,store/* useStore */.oR)().auth.user;
    var pathNameArr = router.pathname.split("/").filter(function(x) {
        return x !== "";
    });
    var keyPrefix = ((ref = pathNameArr[0]) === null || ref === void 0 ? void 0 : ref.replace("App", "")) || "";
    var t = (0,esm/* useTranslation */.$G)("pages").t;
    var getPlatform = function() {
        if (user === false || user === undefined) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicePlatformChoice/* default */.Z, {
                className: (CenterLayout_module_default()).newBg
            });
        }
        return "";
    };
    (0,react.useEffect)(function() {
        var intervalId = setInterval(function() {
            getPlatform();
        }, 1000);
        return function() {
            clearInterval(intervalId);
        };
    }, [
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: (CenterLayout_module_default()).page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((CenterLayout_module_default()).bg, (0,_define_property/* default */.Z)({}, (CenterLayout_module_default()).nativeApp, nativeApp))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((CenterLayout_module_default()).page, (0,_define_property/* default */.Z)({}, (CenterLayout_module_default()).nativeApp, nativeApp)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CenterLayout_module_default()).banner,
                        children: t("header", {
                            keyPrefix: keyPrefix
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CenterLayout_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sideBar, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CenterLayout_module_default()).contentBody,
                                children: [
                                    showBreadcrumbs ? /*#__PURE__*/ (0,jsx_runtime.jsx)(breadCrumbs, {
                                        detail: detail
                                    }) : "",
                                    children
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CenterLayout_module_default()).space,
                children: "\xa0"
            })
        ]
    });
}
CenterLayout.propTypes = {
    children: (prop_types_default()).node.isRequired,
    detail: prop_types_default().instanceOf(Object),
    showBreadcrumbs: (prop_types_default()).bool,
    nativeApp: (prop_types_default()).bool
};
CenterLayout.defaultProps = {
    detail: {},
    showBreadcrumbs: true,
    nativeApp: false
};
/* harmony default export */ var centerLayout_CenterLayout = ((0,mobxreact_esm/* observer */.Pi)(CenterLayout));


/***/ }),

/***/ 47472:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"CenterLayout_root_include_ru__blKzN","footer":"CenterLayout_footer__5PgOb","page":"CenterLayout_page__6fQI0","nativeApp":"CenterLayout_nativeApp__pfCso","bg":"CenterLayout_bg__2WniR","banner":"CenterLayout_banner__sq2gT","content":"CenterLayout_content__eY5wB","contentBody":"CenterLayout_contentBody__YJyDQ","module":"CenterLayout_module___SJHu","space":"CenterLayout_space__JMQ30","newBg":"CenterLayout_newBg__Mvm8r"};

/***/ }),

/***/ 37125:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"breadCrumbs_root_include_ru__Dqz1A","footer":"breadCrumbs_footer___cwRK","breadCrumbs":"breadCrumbs_breadCrumbs__mQKJ0","crumb":"breadCrumbs_crumb__76WNe","arrow":"breadCrumbs_arrow__D2zgN"};

/***/ }),

/***/ 91179:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"sideBar_root_include_ru__IKwbm","footer":"sideBar_footer__7Dwv4","tabs":"sideBar_tabs__hkgpW","tabBlock":"sideBar_tabBlock__jlNr2","active":"sideBar_active__2ALEB","tabRow":"sideBar_tabRow__Z0Ych"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3123,1842,9290,9774,2888,179], function() { return __webpack_exec__(88284); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);